import React from "react";

import { ActivityNavbar } from "./parts/activity-navbar";
import { ActivityLog } from "./parts/activityLog";

export function SimulatorActivity() {
  return (
    <div className="w-full h-full flex flex-col">
      <ActivityNavbar />
      <ActivityLog />
    </div>
  );
}
